import {OrbitComponent} from "../../../../../base-components/orbit-component/orbit-component";
import {observer} from "mobx-react";
import {GamePcHeaderBarClockBox} from "../../boxes/clock/game-pc-header-bar-clock.box";
import React from "react";
import {CyClass} from "../../../../../../../common/cy-classes";
import {ClockComponent} from "../../../../../clock/clock.component";

export const GamePcHeaderBarClockComponent = observer(class GamePcHeaderBarClockComponent extends OrbitComponent {
    render() {
        return (
            <ClockComponent box={GamePcHeaderBarClockBox}
                            className={CyClass('cy-game-navbar-clock')}
            />
        )
    }
});